// extracted by mini-css-extract-plugin
export default {"mainFieldContainer":"MyRnDProjectsPage_mainFieldContainer__wBiMT","adminIconArea":"MyRnDProjectsPage_adminIconArea__S4JL-"};